var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoView"},[_c('Artplayer',{style:(_vm.artplayerObj.style),attrs:{"option":_vm.artplayerObj.option,"mediaInfo":_vm.artplayerObj.info},on:{"get-instance":_vm.getInstance}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }